module.exports = __webpack_public_path__ + "front/img/edm-bj-xianxia.5536478a.png";